import React, { useState } from "react";
import { useSelector } from "react-redux";
import AddProjectModal from "./AddProjectModal";
import ProjectItem from "./ProjectItem";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

export default function ProjectItems() {
    const { states } = useSelector(state => state.projects);
    const [openModal, setOpenModal] = useState(false);

    const controlModal = () => {
        setOpenModal((prevState) => !prevState);
    };

    return (
        <DndProvider backend={HTML5Backend}>
            <div className="flex flex-grow px-10 mt-4 space-x-6 overflow-auto">
                {states.map(state => <ProjectItem key = {state} state = {state} setOpenModal = {setOpenModal} />)}
                <div className="flex-shrink-0 w-6"></div>
            </div>
            <AddProjectModal open = {openModal} control = {controlModal} />
        </DndProvider>
    )
}